@if (inited) {
<div class="flex-col-fixed-fill">
    <sm-toolbar>
        <p-button class="mr-1" icon="fas fa-save" [label]="app.t('general.save')" (onClick)="save()">
        </p-button>
        <p-button icon="fas fa-times" [label]="app.t('general.cancel')" (onClick)="cancel()">
        </p-button>
    </sm-toolbar>
    <div class="grid-2-col">
        <p-card>
            <sm-form [form]="form">
            </sm-form>
        </p-card>
        <p-tree #tree [value]="pupilsTree.items" selectionMode="checkbox" [(selection)]="pupilsTree.selected"></p-tree>
    </div>
</div>
}